import Utils, {isLandingTelmexEnabled} from "../../../utils/Utils";
import {
  APP_ID_TIZEN,
  APP_ID_WEBOS,
  KEY_CONFIGS,
  KEY_TIMESTAMP_MODAL,
  SUPPRESSION_WINDOW_MS
} from "./constants";
import {AAF_MODAL_CHANGE_AAF_TO_CLARO_TV, HIDE_MODAL, showModal} from "../../../actions/modal";
import store from "../../../store";
import Metadata from "../../../requests/apa/Metadata";
import DataStorage from "../../DeviceStorage/LocalStorage";

export const getConfig = () => {
  const fallbackConfig = {enable: false, mandatory: false, appIdTizen: APP_ID_TIZEN};

  try {
    const configData = JSON.parse(Metadata.get(KEY_CONFIGS));
    const region = DataStorage.getItem('region') || 'default';
    const defaultConfig = configData.default || {};
    const regionConfig = configData[region] || {};

    const effectiveConfig = {...defaultConfig, ...regionConfig};

    const configuredAppIdTizen = effectiveConfig.target_app_id_tizen;
    const appIdTizen = typeof configuredAppIdTizen === 'string' && configuredAppIdTizen.trim()
      ? configuredAppIdTizen.trim()
      : APP_ID_TIZEN;

    const enable = typeof effectiveConfig.enable === 'boolean' ? effectiveConfig.enable : false;
    const mandatory = typeof effectiveConfig.mandatory === 'boolean' ? effectiveConfig.mandatory : false;

    return {enable, mandatory, appIdTizen};
  } catch (e) {
    return fallbackConfig;
  }
};

const getElementToFocus = () => {
  const path = window.location.pathname || '';

  switch (path) {
    case "/landing":
      return isLandingTelmexEnabled() ? '.landing-telmex__button-telmex' : ".aaf_button-primary"
    case "/profile":
      return "#id_profile-avatar-image"
    case "/node/homeuser":
      return "#superdestacado_highlight_link_2"
    default:
      return ".focusable"
  }
}

export const closeModal = () => {
  const classFocus = getElementToFocus();
  DataStorage.setItem(KEY_TIMESTAMP_MODAL, Date.now().toString());
  store.dispatch(showModal({
    modalType: HIDE_MODAL,
    modalProps: {}
  }))
  Utils.setInitialFocusChangeTime(classFocus, 10);
}

const openWebOSStore = (appIdInStore) => {

  if (window.webOS) {
    window.webOS.service.request('luna://com.webos.applicationManager', {
      method: 'launch',
      parameters: {
        id: 'com.webos.app.discovery', // ID nativo de LG Content Store
        params: {
          // Opcional: query/parámetros si deseas llevar al usuario directo a la ficha de una app
          query: `${appIdInStore}`        }
      },
      onSuccess: function (response) {
        console.debug('Tienda LG abierta con éxito', response);
      },
      onFailure: function (error) {
        console.debug('Error al abrir tienda LG:', error);
      }
    });
  }
}

const openTizenStore = (appIdInStore) => {
  if (window.tizen && window.tizen.application) {
    try {
      const appControl = new window.tizen.ApplicationControl(
        'http://tizen.org/appcontrol/operation/view',
        `tizenstore://ProductDetail//${appIdInStore}`,
        null,
        null,
        null
      );

      window.tizen.application.launchAppControl(
        appControl,
        'org.tizen.tizenstore',
        function() { console.log('Tienda abierta con éxito'); },
        function(err) { console.error('Error al abrir la tienda:', err); },
        null
      );
    } catch (e) {
      console.error('Error invocando tizen API:', e);
    }
  }
}

export const handleOpenAppStore = () => {
  const isWeb0s = Utils.isWeb0s();
  const isTizen = Utils.isTizen();
  const { appIdTizen } = getConfig();
  const haveIdAppTizen = typeof appIdTizen === 'string' && appIdTizen !== '';
  const haveIdAppWebOs = typeof APP_ID_WEBOS === 'string' && APP_ID_WEBOS !== '';

  if (isTizen && haveIdAppTizen) {
    openTizenStore(appIdTizen);
  } else if (isWeb0s && haveIdAppWebOs) {
    openWebOSStore(APP_ID_WEBOS);
  } else {
    console.warn('[ModalChangeAAFToClaroTV] No hay una tienda compatible o un ID de aplicación válido configurado.');
  }
}

export const reviewChangeAAFClaroTV = () => {
  const {enable, mandatory} = getConfig();

  if (enable !== true) {
    return;
  }

  if (mandatory === true) {
    store.dispatch(showModal({
      modalType: AAF_MODAL_CHANGE_AAF_TO_CLARO_TV,
      modalProps: {
        showSecondaryButton: false
      }
    }))
    return;
  }

  const timestamp = DataStorage.getItem(KEY_TIMESTAMP_MODAL);
  const lastShown = Number(timestamp);
  const elapsed = Date.now() - lastShown;
  const isValidTimestamp = timestamp !== null && timestamp !== '' && Number.isFinite(lastShown) && elapsed >= 0;

  if (isValidTimestamp && elapsed < SUPPRESSION_WINDOW_MS) {
    return;
  }

  store.dispatch(showModal({
    modalType: AAF_MODAL_CHANGE_AAF_TO_CLARO_TV,
    modalProps: {
      showSecondaryButton: true
    }
  }))
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalChangeAAFToClaroTV/utils.js